import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const CheckboxContainer = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
`;

export const HiddenCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
`;

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledCheckbox = styled.div<{
  $checked: boolean;
  $isError?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 2px solid
    ${(props) =>
      props.$checked
        ? customPalette.blue.main
        : props.$isError
          ? '#8D0909'
          : customPalette.grey[200]};
  border-radius: 8px;
  transition: all 150ms;
  position: relative;
  background: ${customPalette.accent.white};

  svg {
    position: absolute;
    fill: ${customPalette.blue.main};
    width: 18px;
    height: 18px;
    opacity: ${(props) => (props.$checked ? 1 : 0)};
    transition: opacity 150ms;
  }
`;
